import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { userNetworksResponseSchema, type UserNetworksResponse } from '@/schemas/userNetwork';

export const getUserNetworks = httpGetAdapter<UserNetworksResponse, void>({
  url: '/v2/usuario/redes',
  schema: userNetworksResponseSchema,
});
